const getGoBoardStones = board => board.flatMap(boardRow => boardRow.filter(stone => stone !== null));
export { getGoBoardStones };